import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[(_vm.compSelection)?_c(VChipGroup,[_c(VChip,[_vm._v(" "+_vm._s(_vm.compSelection))])],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }